import React from 'react'
import styled, { css } from 'styled-components'
import Link from 'components/link'
import { TABS } from 'components/tabLayout/constants'
import withRootContext from 'context/withRootContextHOC'
import CloseIcon from 'static/icons/close-menu-icon.svg'
import UserIcon from 'static/icons/user-menu-icon.svg'
import LogoutOutline from 'static/icons/logout-outline.svg'
import MODAL from 'utils/modals'

export const MenuBlock = styled.div`
  opacity: ${props => props.active ? '1' : '0'};
  left: ${props => props.active ? '0' : '-80vw'};
  top: 0;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  width: 80vw;
  background-color: var(--the-gray);
  z-index: 500;
  transition: all ease .2s;
  overflow: scroll;
`

export const MenuHeader = styled.div`
  background-color: var(--the-white);
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.08));
`

export const UserInfo = styled.div`
  display: flex;
  align-items: center;

  > div {
    width: 4.2rem;
    height: 4.2rem;
    overflow: hidden;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  p {
    color: var(--gray-2);
    font-size: 16px;
    font-family: var(--primary-font);
    font-weight: 600;
  }

  ${({ hasUser }) => !hasUser && css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `}
`
export const UserInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`
export const Wrapper = styled.span`
  font-size: 13px;
  font-family: var(--primary-font);
  font-weight: 400;
  color: var(--gray-5);
`

export const CloseButton = styled.button`
  display: block;
  border: none;
  background-color: transparent;
  width: 24px;
  height: 24px;

  svg {
    width: 24px;
    height: 24px;
    fill: var(--gray-5)
  }
`
export const UserLinks = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--the-white);
`

export const Tab = styled.section`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  font-family: var(--primary-font);
  color: var(--gray-5);
  &:hover {
    background-color: var(--the-gray);
  }
  ${({ secondary }) => secondary && `
      color: var(--cobasi-blue-light-8);
      svg {
        path {
          fill: var(--cobasi-blue-light-8);
        }
      }
  `}
  a {
    color: inherit;
    display: block;
    text-decoration: none;
  }
`

const MenuContent = ({ toggleMenu, active, firstName, isReactNative, onLogout, context: { toggleModalSheet } }) => {
  const hasUser = !!firstName

  const openAuthModal = () => {
    toggleMenu()
    toggleModalSheet(MODAL.LOGIN_MODAL({ onCancel: toggleModalSheet, callback: toggleModalSheet }))
  }

  return (
    <MenuBlock active={active} data-test='menuBlock'>
      <MenuHeader>
        <UserInfoWrapper>
          <UserIcon />
          <UserInfo hasUser={hasUser} onClick={() => { if (!hasUser) openAuthModal() }} data-test='button-menu-login-logout'>
            <p>{hasUser ? `Olá, ${firstName}` : 'Bem-vindo'}</p>
            {!hasUser && (
              <Wrapper data-test='text-login-register'>Entre ou Cadastre-se</Wrapper>
            )}
          </UserInfo>
        </UserInfoWrapper>
        <CloseButton onClick={toggleMenu}>
          <CloseIcon />
        </CloseButton>
      </MenuHeader>

      <UserLinks data-test='userLinks'>
        {
          TABS.map((tab, index) => {
            const { hideOnApp, onlyLogged, icon, href, menuTitle, title } = tab

            if (isReactNative && hideOnApp) return
            if (onlyLogged && !hasUser) return

            return (
              <Tab key={'menu-tab-item-000' + index}>
                {icon}
                <Link href={href}><a onClick={toggleMenu}>{menuTitle ?? title}</a></Link>
              </Tab>
            )
          })
        }
        {hasUser && <Tab onClick={onLogout}><LogoutOutline /><a onClick={toggleMenu}>Sair da conta</a></Tab>}
      </UserLinks>
    </MenuBlock>
  )
}

export default withRootContext(MenuContent)
